import { EventBus } from '@/utils/eventBus'

class NetworkStatus {
  constructor () {
    this.online = navigator.onLine
    this.initEventListeners()
  }

  initEventListeners () {
    window.addEventListener('online', () => {
      this.online = true
      EventBus.$emit('network-status-changed', true)
    })

    window.addEventListener('offline', () => {
      this.online = false
      EventBus.$emit('network-status-changed', false)
    })
  }

  isOnline () {
    return this.online
  }
}

export default new NetworkStatus()
